// src/pages/workflow/RevisionAdministrativa.jsx - CÓDIGO COMPLETO CORREGIDO
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader,
  Button,
  Grid,
  Typography,
  Box,
  Divider,
  Paper,
  Tooltip,
  IconButton,
  LinearProgress,
  Alert,
  AlertTitle,
  Chip,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction
} from '@mui/material';
import {
  Gavel as GavelIcon,
  Dashboard as DashboardIcon,
  Refresh as RefreshIcon,
  Home as HomeIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  PendingActions as PendingIcon,
  Visibility as VisibilityIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Edit as EditIcon,
  CloudUpload as UploadIcon
} from '@mui/icons-material';
import { 
  obtenerDocumentosRequeridos,
  iniciarRevisionDocumento,
  finalizarRevisionDocumento,
  abrirModalRevisionDocumento,
  cerrarModalRevisionDocumento,
  limpiarError,
  obtenerEstadoInscripcion
} from '../../redux/slices/workflowSlice';
import DocumentoRevisionCard from '../../components/workflow/DocumentoRevisionCard';
import ModalRevisionDocumento from '../../components/workflow/ModalRevisionDocumento';
import FiltrosRevision from '../../components/workflow/FiltrosRevision';
import ResumenRevision from '../../components/workflow/ResumenRevision';
import AlertaEstado from '../../components/workflow/AlertaEstado';
import useStyles from '../../theme/useStyles';
import { obtenerEntidadPorId } from '../../actions/EntidadAction';

const RevisionAdministrativa = () => {
  const { entidadId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();

  const {
    documentosRequeridos,
    modalRevisionDocumento,
    loading,
    error
  } = useSelector(state => state.workflow);

  const session = useSelector(state => state.session);
  const { isLoggedIn, username, user: userData } = session;

  const user = userData ? {
    nombre: userData.nombreCompleto || userData.nombre || username || 'Usuario',
    email: userData.email || username || '',
    rol: userData.rol || (userData.roles && userData.roles[0]) || 'Usuario',
    admin: userData.admin || false,
    roles: userData.roles || []
  } : {
    nombre: username || 'Usuario',
    email: username || '',
    rol: 'Usuario',
    admin: false,
    roles: []
  };

  const esAdmin = (userData?.admin === true) || 
                  (userData?.rol === 'Admin') || 
                  (userData?.roles && userData.roles.includes('Admin')) ||
                  (session?.esAdmin === true);

  const [workflowNegocioId, setWorkflowNegocioId] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState('todos');

  const tienePermisos = esAdmin || session.esAdmin;

  const [entidadInfo, setEntidadInfo] = useState(null);

  const cargarInformacionEntidad = async () => {
    try {
      console.log('Cargando información real de la entidad:', entidadId);
      
      const entidadResponse = await obtenerEntidadPorId(entidadId);
      
      if (entidadResponse.status === 200) {
        console.log('Información de entidad cargada:', entidadResponse.data);
        setEntidadInfo({
          id: entidadResponse.data.id,
          nombre: entidadResponse.data.nombre || entidadResponse.data.razonSocial || `Entidad ${entidadId}`,
          tipoEntidad: entidadResponse.data.tipoEntidad,
          nit: entidadResponse.data.nit,
          estado: entidadResponse.data.estado || 'Activa'
        });
      } else {
        console.error('Error en respuesta de entidad:', entidadResponse);
        setEntidadInfo({ 
          id: entidadId, 
          nombre: `Entidad ID: ${entidadId}` 
        });
      }
    } catch (error) {
      console.error('Error cargando información de entidad:', error);
      setEntidadInfo({ 
        id: entidadId, 
        nombre: `Entidad ID: ${entidadId}` 
      });
    }
  };


  useEffect(() => {
    if (entidadId && tienePermisos) {
      obtenerWorkflowId();
    }
  }, [entidadId, tienePermisos]);

  const obtenerWorkflowId = async () => {
    try {
      console.log('Obteniendo estado para entidad:', entidadId);
      
      const resultado = await dispatch(obtenerEstadoInscripcion(entidadId));
      
      await cargarInformacionEntidad();
      
      console.log('resultado payload obtenido en estado: ', resultado.payload);
      
      if (resultado.payload?.esExitoso && resultado.payload?.estado) {
        setWorkflowNegocioId(resultado.payload.estado.workflowNegocioId);
      } else {
        setWorkflowNegocioId(1); // Temporal para desarrollo
      }
    } catch (error) {
      console.error('Error obteniendo workflow ID:', error);
      setWorkflowNegocioId(1);
    }
  };

  useEffect(() => {
    if (workflowNegocioId) {
      console.log('📋 Obteniendo documentos para workflowNegocioId:', workflowNegocioId);
      dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
    }
  }, [workflowNegocioId, dispatch]);

  // *** FUNCIONES AUXILIARES CORREGIDAS SEGÚN LOS ESTADOS REALES ***
  const puedeRevisar = (documento) => {
    // Estado 2 = RADICADO (puede iniciar revisión)
    return documento.estadoDocumentoId === 2;
  };

  const estaEnRevision = (documento) => {
    // Estado 3 = EN_REVISION (puede finalizar revisión)
    return documento.estadoDocumentoId === 3;
  };

  const estaAprobado = (documento) => {
    // Estado 4 = APROBADO
    return documento.estadoDocumentoId === 4;
  };

  const estaRechazado = (documento) => {
    // Estados 5 = RECHAZADO, 7 = PENDIENTE_RECARGA
    return documento.estadoDocumentoId === 5 || documento.estadoDocumentoId === 7;
  };

  const estaSubido = (documento) => {
    // NUEVO: Estado 8 = SUBIDO (pendiente de radicación)
    return documento.estadoDocumentoId === 8;
  };

  const handleIniciarRevision = async (documento) => {
    try {
      const resultado = await dispatch(iniciarRevisionDocumento(documento.id));
      
      if (resultado.payload?.esExitoso) {
        dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
      }
    } catch (error) {
      console.error('Error iniciando revisión:', error);
    }
  };

  const handleAbrirModalRevision = (documento) => {
    dispatch(abrirModalRevisionDocumento(documento));
  };

  const handleFinalizarRevision = async (decision) => {
    try {
      const revisionData = {
        documentoRequeridoId: modalRevisionDocumento.documentoSeleccionado.id,
        estadoDocumentoId: decision.estado,
        usuarioRevisor: null,
        comentarioRevision: decision.comentario
      };

      const resultado = await dispatch(finalizarRevisionDocumento(revisionData));
      
      // if (resultado.payload?.esExitoso) {
      //   dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
      //   dispatch(cerrarModalRevisionDocumento());
      // }

      if (resultado.payload?.esExitoso) {
        // ✅ CORRECCIÓN 1: Siempre refrescar documentos después de finalizar revisión
        await dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
        
        // ✅ CORRECCIÓN 2: Verificar si todos los documentos están aprobados
        const documentosActualizados = await dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
        
        if (documentosActualizados.payload?.datos) {
          const todosAprobados = documentosActualizados.payload.datos.every(doc => doc.estadoDocumentoId === 4);
          
          if (todosAprobados) {
            // ✅ CORRECCIÓN 3: Refrescar también el estado del workflow principal
            console.log('🎉 Todos los documentos aprobados - actualizando estado del workflow');
            
            // Obtener la entidadId del documento para refrescar el estado completo
            const entidadId = modalRevisionDocumento.documentoSeleccionado.entidadId;
            if (entidadId) {
              await dispatch(obtenerEstadoInscripcion(entidadId));
            }
            
            // ✅ CORRECCIÓN 4: Forzar una re-renderización del estado
            setTimeout(async () => {
              await dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
            }, 1000); // Esperar 1 segundo para que el backend procese completamente
          }
        }
        
        dispatch(cerrarModalRevisionDocumento());
      }
    } catch (error) {
      console.error('Error finalizando revisión:', error);
    }
  };

  const handleVerDocumento = (documento) => {
    if (documento.urlDescarga) {
      window.open(documento.urlDescarga, '_blank');
    } else {
      console.warn('No hay URL de descarga disponible para este documento');
    }
  };

  // *** FILTROS CORREGIDOS ***
  const documentosFiltrados = documentosRequeridos.filter(doc => {
    switch (filtroEstado) {
      case 'pendientes_radicacion':
        return estaSubido(doc); // Estado 8 = SUBIDO
      case 'pendientes_revision':
        return puedeRevisar(doc); // Estado 2 = RADICADO
      case 'en_revision':
        return estaEnRevision(doc); // Estado 3 = EN_REVISION
      case 'aprobados':
        return estaAprobado(doc); // Estado 4 = APROBADO
      case 'rechazados':
        return estaRechazado(doc); // Estados 5, 7
      case 'requiere_correccion':
        return doc.estadoDocumentoId === 6; // Estado 6 = REQUIERE_CORRECCION
      default:
        return true;
    }
  });

  // *** ESTADÍSTICAS CORREGIDAS ***
  const estadisticas = {
    total: documentosRequeridos.length,
    pendientesRadicacion: documentosRequeridos.filter(d => estaSubido(d)).length, // Estado 8
    pendientesRevision: documentosRequeridos.filter(d => puedeRevisar(d)).length, // Estado 2
    enRevision: documentosRequeridos.filter(d => estaEnRevision(d)).length, // Estado 3
    aprobados: documentosRequeridos.filter(d => estaAprobado(d)).length, // Estado 4
    rechazados: documentosRequeridos.filter(d => d.estadoDocumentoId === 5).length, // Solo estado 5
    requierenCorreccion: documentosRequeridos.filter(d => d.estadoDocumentoId === 6 || d.estadoDocumentoId === 7).length // Estados 6, 7
  };

  const porcentajeRevisado = estadisticas.total > 0 
    ? Math.round(((estadisticas.aprobados + estadisticas.rechazados + estadisticas.requierenCorreccion) / estadisticas.total) * 100)
    : 0;

  const todoRevisado = estadisticas.pendientesRevision === 0 && estadisticas.enRevision === 0;

  // *** FUNCIÓN PARA OBTENER ÍCONO CORREGIDA ***
  const getDocumentStatusIcon = (documento) => {
    switch (documento.estadoDocumentoId) {
      case 1: return <PendingIcon color="disabled" />; // PENDIENTE
      case 8: return <UploadIcon color="info" />; // SUBIDO (NUEVO)
      case 2: return <AssignmentIcon color="primary" />; // RADICADO - Pendiente revisión
      case 3: return <EditIcon color="warning" />; // EN_REVISION
      case 4: return <CheckCircleIcon color="success" />; // APROBADO
      case 5: case 7: return <ErrorIcon color="error" />; // RECHAZADO
      case 6: return <WarningIcon color="warning" />; // REQUIERE_CORRECCION
      default: return <PendingIcon color="disabled" />;
    }
  };

  // *** FUNCIÓN PARA OBTENER CHIP CORREGIDA ***
  const getDocumentStatusChip = (documento) => {
    switch (documento.estadoDocumentoId) {
      case 1: return <Chip label="Sin subir" color="default" size="small" />;
      case 8: return <Chip label="Subido" color="info" size="small" />; // NUEVO
      case 2: return <Chip label="Pendiente revisión" color="primary" size="small" />;
      case 3: return <Chip label="En revisión" color="warning" size="small" />;
      case 4: return <Chip label="Aprobado" color="success" size="small" />;
      case 5: return <Chip label="Rechazado" color="error" size="small" />;
      case 6: return <Chip label="Requiere corrección" color="warning" size="small" />;
      case 7: return <Chip label="Pendiente recarga" color="error" size="small" />;
      default: return <Chip label="Desconocido" color="default" size="small" />;
    }
  };

  // *** DEBUG: Agregar console.log para verificar datos ***
  useEffect(() => {
    if (documentosRequeridos.length > 0) {
      console.log('=== DEBUG REVISIÓN ADMINISTRATIVA ===');
      console.log('Total documentos:', documentosRequeridos.length);
      console.log('Documentos por estado:');
      
      const estadosCounts = documentosRequeridos.reduce((acc, doc) => {
        acc[doc.estadoDocumentoId] = (acc[doc.estadoDocumentoId] || 0) + 1;
        return acc;
      }, {});
      
      console.table(estadosCounts);
      
      console.log('Documentos EN_REVISION (estado 3):', 
        documentosRequeridos.filter(d => d.estadoDocumentoId === 3).length);
      console.log('Documentos RADICADOS (estado 2):', 
        documentosRequeridos.filter(d => d.estadoDocumentoId === 2).length);
        
      // Verificar URLs de descarga
      const conURL = documentosRequeridos.filter(d => d.urlDescarga).length;
      console.log('Documentos con URL descarga:', conURL);
      
      console.log('=====================================');
    }
  }, [documentosRequeridos]);

  if (!isLoggedIn) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        flexDirection: 'column'
      }}>
        <CircularProgress size={60} sx={{ mb: 2 }} />
        <Typography variant="h6" color="text.secondary">
          Debe iniciar sesión para acceder a esta página
        </Typography>
      </Box>
    );
  }

  if (!tienePermisos) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '100vh',
        p: 2
      }}>
        <Card sx={{ maxWidth: 800, width: '100%', mt: 4 }}>
          <CardHeader 
            title="Acceso Denegado"
            avatar={<ErrorIcon color="error" />}
          />
          <CardContent>
            <Alert severity="error" sx={{ mb: 2 }}>
              <AlertTitle>Sin permisos de administrador</AlertTitle>
              Para acceder a la revisión administrativa necesita rol de 'Admin' o 'Auditor'
            </Alert>
            
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate(`/inscripcion/${entidadId}`)}
              >
                Volver al Dashboard
              </Button>
              <Button
                variant="outlined"
                onClick={() => window.location.reload()}
              >
                Recargar
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      minHeight: '100vh',
      p: 2,
      boxSizing: 'border-box'
    }}>
      <Card className={classes.card}
        sx={{ 
          width: '100%',
          maxWidth: 1400,
          margin: 'auto',
          mt: 4,
          p: 2
        }}
      >
        <CardHeader 
          classes={{ title: classes.cardTitle }}
          avatar={
            <GavelIcon style={{ fontSize: "large", color: "#494949" }} />
          }
          title="Revisión Administrativa" 
          //subheader={`Revisar y aprobar documentos de la entidad ${entidadId} | Usuario: ${user.nombre} (${user.rol})`}
          subheader={`${entidadInfo?.nombre || `Entidad ID: ${entidadId}`} | Usuario: ${user?.nombre || user?.rol}`}
          action={
            <Grid container spacing={1} alignItems="center" justifyContent="center">
              <Grid item>
                <Tooltip title="Actualizar" arrow classes={{ tooltip: classes.tooltip }}>
                  <IconButton
                    onClick={() => {
                      if (workflowNegocioId) {
                        dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
                      }
                    }}
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.button}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title="Volver al Dashboard" arrow classes={{ tooltip: classes.tooltip }}>
                  <IconButton
                    onClick={() => navigate(`/inscripcion/${entidadId}`)}
                    variant="contained"
                    color="secondary"
                    size="small"
                    className={classes.button}
                  >
                    <DashboardIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title="Inicio" arrow classes={{ tooltip: classes.tooltip }}>
                  <IconButton
                    onClick={() => navigate('/')}
                    variant="contained"
                    color="secondary"
                    size="small"
                    className={classes.button}
                  >
                    <HomeIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          }
          sx={{ 
            '& .MuiCardHeader-title': { fontSize: '1.25rem' },
            pr: 6
          }}
        />
        
        <CardContent sx={{ '&:last-child': { pb: 2 } }}>
          {/* Alertas */}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => dispatch(limpiarError())}>
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>
          )}

          {workflowNegocioId === null && tienePermisos && (
            <Alert severity="info" sx={{ mb: 3 }}>
              <AlertTitle>Cargando información del workflow</AlertTitle>
              Obteniendo datos del proceso de inscripción para la entidad {entidadId}...
            </Alert>
          )}

          {workflowNegocioId && todoRevisado && estadisticas.total > 0 && (
            <Alert severity="success" sx={{ mb: 3 }}>
              <AlertTitle>Revisión Completa</AlertTitle>
              {estadisticas.aprobados === estadisticas.total
                ? "¡Todos los documentos han sido aprobados! El proceso puede finalizar."
                : `Revisión completa: ${estadisticas.aprobados} aprobados, ${estadisticas.rechazados + estadisticas.requierenCorreccion} requieren atención.`
              }
            </Alert>
          )}

          {/* Resumen estadístico */}
          {workflowNegocioId && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                Resumen de Revisión
              </Typography>
              
              <Paper elevation={1} sx={{ p: 3, mb: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
                    Progreso de Revisión
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {estadisticas.aprobados + estadisticas.rechazados + estadisticas.requierenCorreccion} de {estadisticas.total} revisados
                  </Typography>
                </Box>
                
                <LinearProgress 
                  variant="determinate" 
                  value={porcentajeRevisado} 
                  sx={{ height: 8, borderRadius: 5, mb: 3 }}
                  color={porcentajeRevisado === 100 ? 'success' : 'primary'}
                />

                <Grid container spacing={2}>
                  <Grid item xs={6} sm={2}>
                    <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'info.50', border: '1px solid', borderColor: 'info.200' }}>
                      <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'info.600' }}>
                        {estadisticas.pendientesRadicacion}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Subidos
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'primary.50', border: '1px solid', borderColor: 'primary.200' }}>
                      <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.600' }}>
                        {estadisticas.pendientesRevision}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Pendientes
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'warning.50', border: '1px solid', borderColor: 'warning.200' }}>
                      <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'warning.600' }}>
                        {estadisticas.enRevision}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        En Revisión
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'success.50', border: '1px solid', borderColor: 'success.200' }}>
                      <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'success.600' }}>
                        {estadisticas.aprobados}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Aprobados
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'error.50', border: '1px solid', borderColor: 'error.200' }}>
                      <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'error.600' }}>
                        {estadisticas.rechazados}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Rechazados
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'orange.50', border: '1px solid', borderColor: 'orange.200' }}>
                      <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'orange.600' }}>
                        {estadisticas.requierenCorreccion}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Correcciones
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          )}

          {/* Filtros CORREGIDOS */}
          {workflowNegocioId && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                Filtrar Documentos
              </Typography>
              
              <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.50' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {[
                    { id: 'todos', label: 'Todos', count: estadisticas.total },
                    { id: 'pendientes_radicacion', label: 'Subidos', count: estadisticas.pendientesRadicacion },
                    { id: 'pendientes_revision', label: 'Pendientes Revisión', count: estadisticas.pendientesRevision },
                    { id: 'en_revision', label: 'En Revisión', count: estadisticas.enRevision },
                    { id: 'aprobados', label: 'Aprobados', count: estadisticas.aprobados },
                    { id: 'rechazados', label: 'Rechazados', count: estadisticas.rechazados },
                    { id: 'requiere_correccion', label: 'Requieren Corrección', count: estadisticas.requierenCorreccion }
                  ].map((filtro) => (
                    <Chip
                      key={filtro.id}
                      label={`${filtro.label} (${filtro.count})`}
                      onClick={() => setFiltroEstado(filtro.id)}
                      color={filtroEstado === filtro.id ? 'primary' : 'default'}
                      variant={filtroEstado === filtro.id ? 'filled' : 'outlined'}
                      sx={{ cursor: 'pointer' }}
                    />
                  ))}
                </Box>
              </Paper>
            </Box>
          )}

          <Divider sx={{ my: 2 }} />

          {/* Lista de Documentos */}
          {workflowNegocioId && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                Documentos para Revisión
              </Typography>
              
              <Paper elevation={1}>
                {loading.obtenerDocumentos ? (
                  <Box sx={{ p: 4, textAlign: 'center' }}>
                    <CircularProgress sx={{ mb: 2 }} />
                    <Typography variant="body2" color="text.secondary">
                      Cargando documentos...
                    </Typography>
                  </Box>
                ) : documentosFiltrados.length === 0 ? (
                  <Box sx={{ p: 8, textAlign: 'center' }}>
                    <AssignmentIcon sx={{ fontSize: 80, color: 'grey.300', mb: 2 }} />
                    <Typography variant="h6" sx={{ fontWeight: 'medium', mb: 1 }}>
                      No hay documentos para mostrar
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {filtroEstado === 'todos' 
                        ? 'No se encontraron documentos para revisar'
                        : `No hay documentos con estado "${filtroEstado.replace('_', ' ')}"`
                      }
                    </Typography>
                  </Box>
                ) : (
                  <List>
                    {documentosFiltrados.map((documento, index) => (
                      <React.Fragment key={documento.id}>
                        <ListItem sx={{ py: 2 }}>
                          <ListItemIcon>
                            {getDocumentStatusIcon(documento)}
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                                  {documento.nombreTipoDocumento || documento.tipoDocumento}
                                </Typography>
                                {getDocumentStatusChip(documento)}
                              </Box>
                            }
                            secondary={
                              <Box>
                                {documento.descripcionTipoDocumento && (
                                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                    {documento.descripcionTipoDocumento}
                                  </Typography>
                                )}
                                <Typography variant="caption" color="text.secondary">
                                  ID: {documento.id} | Estado: {documento.estadoDocumentoId}
                                  {documento.fechaRadicacion && ` | Radicado: ${new Date(documento.fechaRadicacion).toLocaleDateString()}`}
                                </Typography>
                              </Box>
                            }
                          />
                          <ListItemSecondaryAction>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              {/* Botón Ver */}
                              {documento.urlDescarga && (
                                <Tooltip title="Ver documento">
                                  <IconButton 
                                    size="small" 
                                    color="primary"
                                    onClick={() => handleVerDocumento(documento)}
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                </Tooltip>
                              )}
                              
                              {/* Botón Iniciar Revisión - CORREGIDO: estado 2 (RADICADO) */}
                              {puedeRevisar(documento) && (
                                <Tooltip title="Iniciar revisión">
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<EditIcon />}
                                    onClick={() => handleIniciarRevision(documento)}
                                    disabled={loading.iniciarRevision}
                                  >
                                    Iniciar
                                  </Button>
                                </Tooltip>
                              )}
                              
                              {/* Botón Revisar - CORREGIDO: estado 3 (EN_REVISION) */}
                              {estaEnRevision(documento) && (
                                <Tooltip title="Completar revisión">
                                  <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<GavelIcon />}
                                    onClick={() => handleAbrirModalRevision(documento)}
                                  >
                                    Revisar
                                  </Button>
                                </Tooltip>
                              )}
                            </Box>
                          </ListItemSecondaryAction>
                        </ListItem>
                        {index < documentosFiltrados.length - 1 && <Divider />}
                      </React.Fragment>
                    ))}
                  </List>
                )}
              </Paper>
            </Box>
          )}

          {/* Acciones Masivas */}
          {workflowNegocioId && (estadisticas.pendientesRevision > 0 || estadisticas.enRevision > 0) && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                Acciones Rápidas
              </Typography>
              
              <Paper elevation={1} sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  {estadisticas.pendientesRevision > 0 && (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => alert('Funcionalidad en desarrollo: Iniciar revisión masiva')}
                      disabled={loading.iniciarRevision}
                    >
                      Iniciar Revisión de Todos ({estadisticas.pendientesRevision})
                    </Button>
                  )}
                  
                  {estadisticas.enRevision > 0 && (
                    <Button
                      variant="contained"
                      color="warning"
                      onClick={() => alert('Funcionalidad en desarrollo: Finalizar revisiones masivas')}
                      disabled={loading.finalizarRevision}
                    >
                      Revisar Todos ({estadisticas.enRevision})
                    </Button>
                  )}
                  
                  <Button
                    variant="outlined"
                    onClick={() => {
                      if (workflowNegocioId) {
                        dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
                      }
                    }}
                    disabled={loading.obtenerDocumentos}
                  >
                    {loading.obtenerDocumentos ? 'Actualizando...' : 'Refrescar Lista'}
                  </Button>
                  
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => navigate('/admin/dashboard')}
                  >
                    Dashboard Admin
                  </Button>
                </Box>
              </Paper>
            </Box>
          )}

          {/* Información de estados para debugging */}
          {workflowNegocioId && documentosRequeridos.length > 0 && (
            <Alert severity="info" sx={{ mt: 3 }}>
              <AlertTitle>Información técnica - Estados de documentos</AlertTitle>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>WorkflowNegocioId:</strong> {workflowNegocioId} | 
                <strong> EntidadId:</strong> {entidadId} | 
                <strong> Total documentos:</strong> {estadisticas.total}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Estados:</strong> 
                Subidos (8): {estadisticas.pendientesRadicacion} | 
                Radicados/Pendientes Rev. (2): {estadisticas.pendientesRevision} | 
                En Revisión (3): {estadisticas.enRevision}
              </Typography>
              <Typography variant="body2">
                <strong>Completados:</strong> 
                Aprobados (4): {estadisticas.aprobados} | 
                Rechazados (5): {estadisticas.rechazados} | 
                Requieren Corrección (6,7): {estadisticas.requierenCorreccion}
              </Typography>
            </Alert>
          )}

          {/* Estado de carga */}
          {loading.obtenerDocumentos && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <CircularProgress size={30} />
              <Typography variant="body2" sx={{ ml: 2, alignSelf: 'center' }}>
                Cargando documentos...
              </Typography>
            </Box>
          )}
        </CardContent>
      </Card>

      {/* Modal de Revisión */}
      {modalRevisionDocumento.abierto && (
        <ModalRevisionDocumento
          documento={modalRevisionDocumento.documentoSeleccionado}
          onFinalizarRevision={handleFinalizarRevision}
          onCancelar={() => dispatch(cerrarModalRevisionDocumento())}
          cargando={loading.finalizarRevision}
        />
      )}
    </Box>
  );
};

export default RevisionAdministrativa;